import {
  CandidateSummaryGapResolutionAction,
  CandidateSummaryGapResolutionEvent,
} from '../models/candidate-summary.model';
import { ASSESSMENT_SECTIONS } from './candidate-summary-labels';

export const GAP_HISTORY_ACTION_LABEL: Record<CandidateSummaryGapResolutionAction, string> = {
  FLAGGED: 'Flagged by AI',
  RESOLVED: 'Resolved for client sharing',
  REOPENED: 'Reopened for review',
  EDITED: 'Updated',
  ADDED: 'Added manually',
  REMOVED: 'Removed',
};

export const GAP_HISTORY_ACTION_COLOR: Record<CandidateSummaryGapResolutionAction, string> = {
  FLAGGED: 'orange',
  RESOLVED: 'green',
  REOPENED: 'gold',
  EDITED: 'blue',
  ADDED: 'purple',
  REMOVED: 'default',
};

export function formatGapHistoryTimestamp(value?: string): string {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export function describeGapHistoryEvent(event: CandidateSummaryGapResolutionEvent): string {
  switch (event.action) {
    case 'FLAGGED':
      return `AI flagged: ${event.gapDescription ?? 'Gap identified'}`;
    case 'RESOLVED':
      return event.resolutionNote
        ? `Closed with note: ${event.resolutionNote}`
        : 'Marked resolved for client sharing';
    case 'REOPENED':
      return 'Moved back to open for further review';
    case 'ADDED':
      return `Recruiter added: ${event.gapDescription ?? 'New gap'}`;
    case 'REMOVED':
      return `Removed: ${event.gapDescription ?? 'Gap item'}`;
    case 'EDITED':
      return 'Gap wording or resolution note updated';
    default:
      return GAP_HISTORY_ACTION_LABEL[event.action];
  }
}

export function gapHistoryEntriesNewestFirst(
  history?: CandidateSummaryGapResolutionEvent[]
): CandidateSummaryGapResolutionEvent[] {
  if (!history?.length) {
    return [];
  }
  return [...history].sort(
    (left, right) =>
      new Date(right.occurredAt).getTime() - new Date(left.occurredAt).getTime()
  );
}

export function countResolvedGapHistory(
  history?: CandidateSummaryGapResolutionEvent[]
): number {
  return history?.filter((event) => event.action === 'RESOLVED').length ?? 0;
}

export { ASSESSMENT_SECTIONS };
